


import React from 'react';
import { Button, Modal, Tabs } from "antd";
import BillConfirmLogView from './components/BillConfirmLogView';
import CompilationView from './components/CompilationView';
import ReceiptConfirmationView from './components/ReceiptConfirmationView';
import RefundConfirmationView from './components/RefundConfirmationView';
import ModalScrollContainer from '../../components/ModalScrollContainer';

const TabPane = Tabs.TabPane
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-20 15:05:11
 * @LastEditTime: 2021-12-21 10:38:26
 * @LastEditors: zhao - 🍉
 * @Description: 对账详情
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/detail.jsx
 */
class AccountingRecordDetail extends React.Component {
    constructor() {
        super();
        this.state = {
            visible: false,
            accountingRecordLogId: null,
        };
    }

    open = (id,loan) => {

        this.setState({ 
            visible: true,
            accountingRecordLogId: id,
            loan: loan
        });
    };

    close = () => {
        this.setState({ visible: false });
    };

    renderFooter = () => {
        return <Button onClick={() => this.close()}>关闭</Button>
    }
    

    render() {
        const labelWidth = 100
        const { accountingRecordLogId } = this.state
        return (
            <Modal destroyOnClose title="对账" visible={this.state.visible} width={955} onCancel={this.close} footer={this.renderFooter()}>
                <ModalScrollContainer>
                    <div className="custom" >
                        {   this.state.loan?
                        <Tabs animated={false}>

                                <TabPane tab="租金汇集明细确认书" key="1">
                                    <BillConfirmLogView labelWidth={labelWidth}
                                                        accountingRecordLogId={accountingRecordLogId}/>
                                </TabPane>
                                <TabPane tab="租金汇集明细" key="2">
                                <CompilationView labelWidth={labelWidth} accountingRecordLogId={accountingRecordLogId} />
                                </TabPane>
                                <TabPane tab="到账确认书" key="3">
                                <ReceiptConfirmationView labelWidth={labelWidth} accountingRecordLogId={accountingRecordLogId} />
                                </TabPane>
                                <TabPane tab="退款确认书" key="4">
                                <RefundConfirmationView labelWidth={labelWidth} accountingRecordLogId={accountingRecordLogId} />
                                </TabPane>

                        </Tabs>:null
                        }
                        {   !this.state.loan?
                            <Tabs animated={false}>
                                {/*<TabPane tab="租金汇集明细确认书" key="1">*/}
                                {/*    <BillConfirmLogView labelWidth={labelWidth}*/}
                                {/*                        accountingRecordLogId={accountingRecordLogId}/>*/}
                                {/*</TabPane>*/}
                                <TabPane tab="租金汇集明细" key="1">
                                    <CompilationView labelWidth={labelWidth} accountingRecordLogId={accountingRecordLogId} />
                                </TabPane>
                                {/*<TabPane tab="到账确认书" key="3">*/}
                                {/*    <ReceiptConfirmationView labelWidth={labelWidth} accountingRecordLogId={accountingRecordLogId} />*/}
                                {/*</TabPane>*/}
                                <TabPane tab="退款确认书" key="2">
                                    <RefundConfirmationView labelWidth={labelWidth} accountingRecordLogId={accountingRecordLogId} />
                                </TabPane>

                            </Tabs>:null
                        }
                    </div>
                </ModalScrollContainer>
            </Modal>
        );
    }
}

export default AccountingRecordDetail;


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/detail.jsx